"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _shops = require("@module/shops");

var _cards = require("@preloader/cards");

var _utils = require("@package/utils");

var _hoc = require("@package/hoc");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _Component = _interopRequireDefault(require("./Component"));

function HOC() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var location = (0, _reactRouterDom.useLocation)();
  var preloadingProcess = (0, _reactRedux.useSelector)(_shops.selectPreloadingProcess);
  var status = null;

  switch (location.pathname) {
    case "".concat(process.env['PUBLIC_URL'], "/shops/inactive"):
      status = 'NotActive';
      break;

    case "".concat(process.env['PUBLIC_URL'], "/shops"):
      status = 'Active';
      break;
  }

  (0, _react.useEffect)(function () {
    dispatch((0, _shops.setStatus)(status));

    var update = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
        var query;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                document.title = "".concat(process.env['REACT_APP_WEBSITE_NAME'], " - \u041C\u0430\u0433\u0430\u0437\u0438\u043D\u044B");
                query = _utils.queryString.parse(location['search']);
                query['status'] = status;
                dispatch((0, _shops.setPreloadingProcess)(true));
                _context.next = 6;
                return dispatch((0, _shops.getShops)(query));

              case 6:
                dispatch((0, _shops.setPreloadingProcess)(false));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function update() {
        return _ref.apply(this, arguments);
      };
    }();

    if (status !== null) {
      update();
    }
  }, [location]);
  (0, _hoc.useUpdate)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
    var query;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = _utils.queryString.parse(location['search']);
            dispatch((0, _shops.setPreloadingProcess)(true));
            _context2.next = 4;
            return dispatch((0, _shops.getShops)(query));

          case 4:
            dispatch((0, _shops.setPreloadingProcess)(false));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
  (0, _hoc.useUnmount)(function () {
    dispatch((0, _shops.resetStateAction)());
  });

  if (preloadingProcess) {
    return /*#__PURE__*/_react["default"].createElement(_cards.Preloader, null);
  } else {
    return /*#__PURE__*/_react["default"].createElement(_Component["default"], null);
  }
}

var _default = HOC;
exports["default"] = _default;